import { Routes, Route } from 'react-router-dom'
import { ConnectorLayout } from './components/layout/ConnectorLayout'
import { ProtectedRoute } from './components/ProtectedRoute'
import { Auth } from './pages/Auth'
import { Dashboard } from './pages/Dashboard'
import { ImportWizard } from './pages/ImportWizard'
import { DataMapping } from './pages/DataMapping'
import { ImportHistory } from './pages/ImportHistory'
import { Settings } from './pages/Settings'
import { SyncStatus } from './pages/SyncStatus'
import { ProviderMarketplace } from './pages/ProviderMarketplace'
import { ManualSync } from './pages/ManualSync'
import { OfflinePosBridge } from './pages/OfflinePosBridge'
import { OnboardingWizardV2 } from './pages/OnboardingWizardV2'

function App() {
  return (
    <Routes>
      {/* Public auth route — no signup, info box links to tenant-admin */}
      <Route path="/login" element={<Auth />} />

      {/* Protected app routes */}
      <Route path="/" element={
        <ProtectedRoute>
          <ConnectorLayout />
        </ProtectedRoute>
      }>
        <Route index element={<OnboardingWizardV2 />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="import" element={<ImportWizard />} />
        <Route path="mapping" element={<DataMapping />} />
        <Route path="history" element={<ImportHistory />} />
        <Route path="sync-status" element={<SyncStatus />} />
        <Route path="marketplace" element={<ProviderMarketplace />} />
        <Route path="manual-sync" element={<ManualSync />} />
        <Route path="offline-bridge" element={<OfflinePosBridge />} />
        <Route path="settings" element={<Settings />} />
      </Route>
    </Routes>
  )
}

export default App